/**
 * The portal's Data map tab: this customer's map, read through the portal route (scoped
 * to the customer and refused unless the tab is on), drawn by the shared DataMap.
 */
import { useCallback, useEffect, useState } from 'react'
import DataMap from '../../components/DataMap/DataMap'
import { getPortalDataMap } from '../../api'

export default function PortalDataMap({ customerId }) {
  const [state, setState] = useState({ data: null, error: null, loading: true })

  const load = useCallback(async (signal) => {
    setState(s => ({ ...s, loading: true, error: null }))
    try {
      const data = await getPortalDataMap(customerId)
      if (!signal?.cancelled) setState({ data, error: null, loading: false })
    } catch (err) {
      if (!signal?.cancelled) setState({ data: null, error: err, loading: false })
    }
  }, [customerId])

  useEffect(() => {
    const signal = { cancelled: false }
    load(signal)
    return () => { signal.cancelled = true }
  }, [load])

  return (
    <div className="cp-section">
      <DataMap data={state.data} loading={state.loading} error={state.error}
        onRetry={() => load()} audience="portal" />
    </div>
  )
}
